import e from"@emotion/styled";import{setAlertClassesNew as i}from"./Alert.utils.js";const l=e.div`
  label: alert;
  display: inline-flex;
  padding-left: 16px;
  padding-right: 16px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  border-radius: 6px;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  max-width: 100%;
  width: 327px;
  ${t=>i(t.variant)}
  ${t=>t.hasShadow&&{boxShadow:"0px 8px 10px rgba(0, 0, 0, 0.1), 0px 3px 8px rgba(0, 0, 0, 0.15)"}};
  ${t=>t.isFullWidth&&{width:"100%"}};
`,r=e.div`
  label: alert-content;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  & > * {
    display: flex;
  }
`,a=e.div`
  label: alert-title;
  font-size: 16px;
  line-height: 28px;
  font-weight: 600;
`,p=e.div`
  label: alert-close-wrapper;
  display: flex;
  margin-right: auto;
  padding-right: 8px;
  align-items: center;
  & > * {
    cursor: pointer;
  }
`;export{l as AlertStyled,p as AlertStyledCloseWrapper,r as AlertStyledContent,a as AlertStyledTitle};
